import calculatePriceIncrement
  from '../../../price-facet-adapter/collaborators/calculate-price-increment';
import formatPriceForDisplay
  from '../../../price-facet-adapter/collaborators/format-price-for-display';
import getMaxSelectionOptions
  from '../../../price-facet-adapter/collaborators/get-max-selection-options';
import getMinSelectionOptions
  from '../../../price-facet-adapter/collaborators/get-min-selection-options';
import roundMaxPriceToNextIncrement
  from '../../../price-facet-adapter/collaborators/round-max-price-to-next-increment';
import roundMinPriceToPreviousIncrement
  from '../../../price-facet-adapter/collaborators/round-min-price-to-previous-increment';

const getAppliedValues = (shouldShow, priceFacet) => {return shouldShow ? [priceFacet] : []};
const getTagDisplayLabel = (shouldShow, appliedRange, range) => {return shouldShow ? formatPriceForDisplay(appliedRange, range) : undefined;};
const getMayBeApplied = applied => {return applied ? {applied} : null;};
const getMayBeAppliedRange = appliedRange => {return appliedRange ? {appliedRange} : null;};
const getMayUseTagDisplayLabel = tagDisplayLabel => {return tagDisplayLabel ? {tagDisplayLabel} : null;};

export const adaptPrice = facet => {
  let min = Math.floor(Number(facet.range.min));
  let max = Math.ceil(Number(facet.range.max));
  let appliedRange = undefined;
  let applied = false;

  const priceRange = {min, max};

  if (facet.appliedRange) {
    const appliedMin = Math.floor(Number(facet.appliedRange.min));
    const appliedMax = Math.ceil(Number(facet.appliedRange.max));

    appliedRange = {min: appliedMin, max: appliedMax};
    applied = true;
  }

  const increment = calculatePriceIncrement(min, max);
  const minOptions = getMinSelectionOptions(
      appliedRange,
      priceRange,
      increment,
  );
  const maxOptions = getMaxSelectionOptions(
      appliedRange,
      priceRange,
      increment,
  );

  min = roundMinPriceToPreviousIncrement(appliedRange, priceRange, increment);
  max = roundMaxPriceToNextIncrement(appliedRange, priceRange, increment);

  const range = {min, max};
  const differenceGreaterOrEqualThanIncrement = max - min >= increment;
  const shouldShow = differenceGreaterOrEqualThanIncrement && applied;
  const tagDisplayLabel = getTagDisplayLabel(shouldShow, appliedRange, range);
  const mayBeApplied = getMayBeApplied(applied);
  const mayBeAppliedRange = getMayBeAppliedRange(appliedRange);
  const mayUseTagDisplayLabel = getMayUseTagDisplayLabel(tagDisplayLabel);

  const priceFacet = {
    ...facet,
    range,
    minOptions,
    maxOptions,
    ...mayBeApplied,
    ...mayBeAppliedRange,
    ...mayUseTagDisplayLabel,
  };
  const appliedValues = getAppliedValues(shouldShow, priceFacet);

  return {
    facet: priceFacet,
    appliedValues,
  };
};